import { defineComponent, ref, watch } from 'vue';
export default defineComponent({
    name: 'AlphabetFilter',
    props: {
        modelValue: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue', 'change'],
    setup(props, { emit }) {
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        const selectedLetter = ref(props.modelValue);
        watch(() => props.modelValue, (newVal) => {
            selectedLetter.value = newVal;
        });
        const selectLetter = (letter) => {
            selectedLetter.value = letter;
            emit('update:modelValue', letter);
            emit('change', letter);
        };
        return {
            alphabet,
            selectedLetter,
            selectLetter
        };
    }
});
